module.exports = __webpack_public_path__ + "static/media/exp--big.f57691f2.png";